import { Api } from "@/core/api.js";
const api = new Api();

// initial state
const state = {
  list: [],
  total_list: 0,
  pagination: { num_page: 0, num_items: 20 },
  current_filters: {},
  isUploading: false
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var aFacilitys = [];
    for (var i in state.list) {
      if (state.list[i].visible) aFacilitys.push(state.list[i]);
    }
    return aFacilitys;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") return state.list[id];
    return false;
  },

  getTotalList: (state, getters, rootState) => () => {
    return state.total_list;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aFacilitys = [];
    for (var i in state.list) {
      aFacilitys.push(state.list[i]);
    }
    return aFacilitys;
  },

  getListKeyId: (state, getters, rootState) => () => {
    return state.list;
  }
};

// actions
const actions = {
  loadList({ commit }, params) {
    var path =
      "facility" +
      (typeof params !== "undefined" && typeof params.event !== "undefined"
        ? "/event/" + params.event
        : "");
    var page_options =
      params && params.page_options ? params.page_options : state.pagination;
    var filters =
      params && params.filters ? params.filters : state.current_filters;
    var oParams = Object.assign(filters ? filters : {}, page_options);

    return api.post(path, oParams).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        commit("setList", { data: data, total: response.data.total });
        return commit("setPagination", page_options);
      }
    });
  },

  load_by_id({ commit }, params) {
    var path = "facility/" + params.id;
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        return commit("addFacility", data);
      }
    });
  },

  uploadFiles(context, data) {
    return new Promise((resolve, reject) => {
      var files = data.files;
      var facility = data.facility;

      if (files.length == 0) {
        resolve(facility);
      } else {
        var file = files.pop();
        var uploaderFile = new Uploader();
        uploaderFile.upload(
          file.file,
          {},
          function(data) {
            facility[file.param] = data.Location;
            context
              .dispatch("uploadFiles", { files: files, facility: facility })
              .then(resolve);
          },
          function(e) {
            context
              .dispatch("uploadFiles", { files: files, facility: facility })
              .then(resolve);
          }
        );
      }
    });
  },

  upload(context, data) {
    var facility = { ...data.data };

    if (data.event) facility.event = data.event;

    delete facility.image_preview;

    var filesUpload = [];
    if (
      typeof facility["image"] !== "string" &&
      typeof facility["image"] !== "undefined" &&
      facility["image"] != null
    ) {
      filesUpload.push({ param: "image", file: facility["image"] });
    }
    context.commit("isUploading", true);
    return context
      .dispatch("uploadFiles", { files: filesUpload, facility: facility })
      .then(function(facility2) {
        if (!context.getters.isUploading) {
          var path =
            typeof facility2.id !== "undefined"
              ? "facility/" + facility2.id + "/update"
              : "facility/add";
          return api.post(path, facility2).then(function(response) {
            if (response.status) {
              var data = response.data;
              data.visible = true;

              context.commit("addFacility", data);
              return data.id;
            }
          });
        }
      });
  },

  remove(context, id) {
    return api.post("facility/" + id + "/remove", {}).then(function(response) {
      if (response.status) {
        var data = response.data;
        data.visible = true;

        context.commit("removeFacility", id);
      }
    });
  },

  addRelFacilityEvent(context, params) {
    return api
      .post(
        "facility/" +
          params.facility_id +
          "/event/" +
          params.event_id +
          "/addrel",
        {}
      )
      .then(function(response) {
        if (response.status) {
          return true;
        } else {
          throw response.error.message;
        }
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data.data;
    state.total_list = data.total;
  },

  addFacility(state, facility) {
    var list = { ...state.list };
    list[facility.id] = facility;

    state.list = list;
  },

  removeFacility(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    state.current_filters = filters;
    // var list = {...state.list};
    // if( !filters ){
    //     for( var i in list ){
    //         list[ i ].visible = true;
    //     }
    // }
    // else {
    //     for( var i in list ){
    //         list[ i ].visible = false;
    //     }
    //     for( var i in list ){
    //         var item = list[ i ];
    //         var bFound = true;
    //         for( var k in filters ){
    //             if ( item[k]== null ) {
    //               bFound = false;
    //               continue;
    //             }
    //             var item_value = ( typeof item[k] == 'object' )? item[k].id : item[k];
    //             // console.log( "ITEM: " + item[k] + " - FILTER: " + filters[k] );
    //             if ( typeof filters[k] === 'string' && filters[k]!= "" && item.hasOwnProperty( k ) && filters[k].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() != item_value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() ) {
    //                 bFound = false;
    //             }
    //             else if(typeof filters[k] != 'string' && item.hasOwnProperty( k ) && filters[ k ] != item_value ) {
    //               bFound = false;
    //             }
    //         }

    //         list[ i ].visible = bFound;

    //     }
    // }

    // state.list = list;
  },
  setPagination(state, value) {
    state.pagination = value;
  },

  isUploading(state, value) {
    state.isUploading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
